var coreClientSideValidation = require("coremh/components/clientSideValidation");
var { changeButtonState } = require("../utils/validationHelper");

/**
 * Changes the disabled button state when all required fields a filled in
 * Use "js-submit-button-state" class on Form element
 */
coreClientSideValidation.submitButtonState = function() {
    let $form = $(".js-submit-button-state");
    $form.each((index, item) => {
        let $formFields = $(item).find(".form-control[required]");
        let $submitBtn = $(item).find("[type='submit']");

        changeButtonState($formFields, $submitBtn);

        $formFields.on("keyup change", function () {
            changeButtonState($formFields, $submitBtn);
        });
    });
};

module.exports = coreClientSideValidation;
